import { showModal, hideModal, showNotification } from '../../../utils.js';
import CompanyService from '../../../services/company.js';

export const setupPaymentModal = (company, onSuccess) => {
    const template = `
        <h3 class="text-lg font-bold mb-4">Управление платежами - ${company.name}</h3>
        <form id="payment-form" class="space-y-4">
            <div>
                <label class="block text-sm font-medium text-gray-700">Статус платежа</label>
                <select name="status" required
                        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
                    <option value="pending" ${company.payment?.status === 'pending' ? 'selected' : ''}>Ожидается</option>
                    <option value="completed" ${company.payment?.status === 'completed' ? 'selected' : ''}>Завершен</option>
                    <option value="failed" ${company.payment?.status === 'failed' ? 'selected' : ''}>Не прошел</option>
                </select>
            </div>
            <div>
                <label class="block text-sm font-medium text-gray-700">Дата платежа</label>
                <input type="datetime-local" name="payment_date" required
                       value="${company.payment?.payment_date ? new Date(company.payment.payment_date).toISOString().slice(0, 16) : ''}"
                       class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500">
            </div>
            <div class="flex justify-end space-x-3">
                <button type="button" id="cancel-payment-btn"
                        class="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                    Отмена
                </button>
                <button type="submit"
                        class="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700">
                    Обновить платеж
                </button>
            </div>
        </form>
    `;

    showModal(template);

    // Add event listener for the cancel button
    document.getElementById('cancel-payment-btn').addEventListener('click', () => {
        hideModal();
    });

    document.getElementById('payment-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const paymentData = {
            status: formData.get('status'),
            payment_date: new Date(formData.get('payment_date')).toISOString()
        };

        try {
            await CompanyService.updatePayment(company.id, paymentData);
            showNotification('Платеж успешно обновлен');
            await onSuccess();
            hideModal();
        } catch (error) {
            showNotification(error.message, 'error');
        }
    });
};
